/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tab_CapabilitiesInputs */



/**
* | output |
* | --- |
* | "Capabilities" |
*
* @param {Rights_Tab_CapabilitiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tab_capabilities = /** @type {((inputs?: Rights_Tab_CapabilitiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tab_CapabilitiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen")
	return /** @type {LocalizedString} */ ("Capabilities")
});